module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "maskable_icon_x192.11bf9ceb.png";